import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Persian() {
  return (
    <ApiCommunityDirectoryPage
      community="Persian"
      eyebrow="Persian community guide"
      title="Persian favorites, businesses, and local essentials in San Antonio."
      
      tags={["Persian community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Persian community guide?"
      modalIdPrefix="persian-directory"
    />
  );
}
